import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import ContractDatatable from './ContractDatatable';
import ContractModal from './ContractModal';



const ContractTab = (props) => {

    
    const [show , setShow]= useState( false ); 
    const [recordId, setRecordId ] = useState();
    const [entityId, setEntityId ] = useState();    
  

    const handleCallback = (id) => {
          setRecordId(id);       
          setShow(true);   
    };
 
    useEffect(() => {
      setEntityId(props.entityId);
    }, [props.entityId])

    const modalCallback = (isShow) => {             
      setShow(isShow);              
    }


  

    return (
        <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
          <ContractDatatable            
            parentCallback={handleCallback}
            entityId={entityId}
            entityName="file"                      
            modalShow={show}                  
          />
          <ContractModal 
            modal={show}
            parentCallback={modalCallback}
            selectedRecord={recordId}
            entityId={entityId}
            entityName="file"            
          />
          <Button
            bsStyle="primary"
          //  bsSize="large"
            className="ml-3 mt-3"
            onClick={() => handleCallback('')} //current => !current
          >
            <i class="fas fa-plus"></i>
          </Button>
        </div>
    );
};

export default ContractTab;